import { MFALockout } from '@organization/api/requests'
import { MenuProps } from 'antd'
import { TFunction } from 'i18next'
import { Trash } from 'iconsax-react'

import { LockoutActionsTypes } from '../LockoutActions'

const iconProps = {
  size: 16
}

export const getActionColumnMenu =
  (
    onClick: (
      modal: {
        type: LockoutActionsTypes
        data: MFALockout
      } | null
    ) => void,
    t: TFunction
  ) =>
  (data: MFALockout): MenuProps['items'] => {
    return [
      {
        label: t('delete'),
        key: 'delete',
        icon: <Trash {...iconProps} />,
        danger: true,
        onClick: () => onClick({ data, type: 'delete' })
      }
    ]
  }
